import React from 'react';
import { CartesianGrid, LabelList, Legend, Line, LineChart, Tooltip, XAxis, YAxis } from 'recharts';
import useData from '../../hooks/useReviews/useData';

const EasyLineChart = () => {
  const [data, setData] = useData();
   return (
      <div>
        <h2> Line chart to see the state monthly </h2>
            <LineChart
      width={500}
      height={400}
      data={data}
      margin={{
        top: 20,
        right: 30,
        left: 20,
        bottom: 10
      }}
    >
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis dataKey="month" height={0}/>
      <YAxis dataKey="investment" />
      <Tooltip />
      <Legend/>
      <Line type="monotone" dataKey="investment" stroke="red">
        <LabelList />
      </Line>
      <Line type="monotone" dataKey="revenue" stroke="green" />
    </LineChart>
      </div>
    );
};

export default EasyLineChart;